export const parsePostMessageData = (data: MessageEvent['data']) => {
    const type = typeof data;

    if (type === 'object' && data !== null) {
        return data;
    }

    if (type === 'string') {
        try {
            return JSON.parse(data);
        } catch (err) {}
    }

    return null;
};
